// extracted by mini-css-extract-plugin
module.exports = {"container":"rotate-device_container__1Llzf","logo":"rotate-device_logo__2A8rL","title":"rotate-device_title__2GH0o","subtitle":"rotate-device_subtitle__3Z9Ud"};